module.exports = __webpack_public_path__ + "static/media/City Life - Ind.Blue_GR Green.44fe0add.jpg";